<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script type="text/ecmascript-6">

export default {
  name: 'App',
  data () {
    return {}
  }
}
</script>

<style>
html,
body {
  padding: 0;
  margin: 0;
  background-color: #f3f5f7;
  overflow-y: visible;
  min-width: 1300px;
}
.el-main {
  padding: 20px 20px;
  margin-left: 210px;
  margin-top: 65px;
}

input[type="radio"] + iafter {
  display: none;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner,
.el-select {
  width: 100%;
}

.btn-plus .el-icon-plus:before {
  color: #000000;
  font-weight: 800;
  font-size: 23px;
}

.zizhiAuthJigou .el-form-item__content {
  margin-left: 108px !important;
}

.zizhiAuthJigou .el-form-item__label {
  width: 108px !important;
}

.w100.upload-demo .el-button .el-icon-plus:before,
.w50.upload-demo .el-button .el-icon-plus:before {
  color: #000000;
  font-weight: 800;
  font-size: 23px;
}
.txImg label {
  line-height: 132px;
}
.txP {
  color: #000000;
  font-size: 12px;
  display: block;
  line-height: 24px;
}
.znjcTable .el-table th > .cell {
  color: #000000;
  text-align: center;
}
.znjcTable .el-table .cell {
  text-align: center;
}
.znjcTable .el-table td,
.el-table th {
  padding: 8px 0;
}

.memberCenter .el-icon-date:before {
  font-size: 20px;
}
/* body{
    background-color: #F3F5F7;
  }*/
.el-aside .el-submenu__title {
  font-size: 15px;
  font-weight: 600;
  height: 50px !important;
  line-height: 50px !important;
  letter-spacing: 1px;
}

.el-aside .el-icon-arrow-down:before {
  /*content: "\E6DF";*/
  font-size: 20px;
}
.el-header
  .headerRbox
  .user-el-menu-demo
  .el-menu--horizontal
  > .el-submenu
  .el-submenu__title {
  /*height: 53px;*/
  /*line-height: 53px;*/
  border-bottom: 2px solid transparent;
  color: #909399;
}
.realNameAuth .idImgBox > .el-form-item__content {
  border: 1px solid #e5e5e5 !important;
  padding: 10px;
  padding-bottom: 47px;
}
.zizhiAuthZj_jianjie .w50box button {
  border: 2px solid #000000;
}
.zizhiAuthZj_jianjie .w50box .el-icon-plus:before {
  color: #000000;
  font-weight: 600;
}
.memberCenter .el-dialog {
  width: 35%;
}
.memberCenter .el-dialog__footer button.jihuobut {
  background-color: #14c86c;
  color: #ffffff;
  font-size: 12px;
}
.memberCenter .el-dialog__headerbtn {
  /*top: 24px;*/
  /*font-size: 28px;*/
}
.memberCenter .el-dialog__body {
  padding: 10px 20px 0;
}
.memberCenter .el-dialog__footer {
  text-align: center;
  /*padding: 10px 20px 0px;*/
}
/*



  */
.memberCenter .el-dialog__header {
  /*padding: 0px 0px 20px;*/
  border-bottom: 1px solid #eeeeee;
}
.zizhiAuthJigou_xgzz .setLine .el-form-item__content {
  line-height: 129px;
}
.paginationBox .el-pagination {
  display: inline-block !important;
}
.paginationBox .el-button {
  padding: 7px 8px;
  position: relative;
  top: 7px;
}

.paginationBox {
  padding-top: 20px;
  padding-bottom: 20px;
  text-align: right;
}
.el-pagination button,
.el-pagination span:not([class*="suffix"]) {
  padding-left: 8px;
  padding-right: 8px;
}
.el-pagination button,
.el-pagination span:not([class*="suffix"]) {
  height: 30px;
  line-height: 30px;
}
.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  background: #fff;
  border: 1px solid #ebeef5;
  color: #727187;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #59677f;
}
.el-button.is-disabled,
.el-button.is-disabled:focus,
.el-button.is-disabled:hover {
  color: #c0c4cc;
  border: 1px solid #c0c4cc;
}
.el-pagination.is-background .btn-next.disabled,
.el-pagination.is-background .btn-next:disabled,
.el-pagination.is-background .btn-prev.disabled,
.el-pagination.is-background .btn-prev:disabled,
.el-pagination.is-background .el-pager li.disabled {
  border: 1px solid #c0c4cc;
  color: #c0c4cc;
}
.paginationBox .totaltext {
  height: 30px;
  line-height: 30px;
  display: inline-block;
  color: #59677f;
  position: relative;
  top: 8px;
  font-size: 14px;
  margin-left: 15px;
}
.paginationBox .totaltext i {
  padding-left: 2px;
  padding-right: 2px;
  color: #000000;
}
.disabled .el-input.is-disabled .el-input__inner {
  background-color: #fff;
  color: #666;
}
/* 订单分页样式微调 */
.dmh-page .el-pagination {
  padding: 0;
}
.dmh-page .el-button {
  top: 9px;
}
.dmh-page .el-pager li {
  height: 30px !important;
  width: 30px !important;
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue